import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {Flex, Grid, useColorModeValue} from "@chakra-ui/react";
import axios from "axios";
import {useAuthHeader} from "react-auth-kit";
import { FaBackspace } from "react-icons/fa";
import Header from "../components/Header";
import BgCharged from "../assets/img/BgCharged.png";
import forta from "../assets/img/avatars/forta.png";
import ProviderParams from "../components/ProviderParams";

export function RateDetails(getAction) {
    const bgProfile = useColorModeValue(
        "hsla(0,0%,100%,.8)",
        "linear-gradient(112.83deg, rgba(255, 255, 255, 0.21) 0%, rgba(255, 255, 255, 0) 110.84%)"
    );
    const { id } = useParams();
    const token = useAuthHeader();
    const [action, setAction] = useState(false)
    const [notObjectResult, setNotObjectResult] = useState([])
    const [objectResult, setObjectResult] = useState([])

    useEffect(() => {
        setAction(getAction)
    },[getAction])

    useEffect(() => {
        if (action){
            let active = true
            const getResult = async () => {
                if (active) {
                    const newData = await fetchData(id, token());
                    let data = Object.values(newData)
                    let keys = Object.keys(newData)

                    let obj = []
                    let notObj = {}
                    for (let i = 0; i < data.length; ++i)
                    {
                        if (typeof data[i] === 'object') {
                            if (data[i] !== null) {
                                obj[keys[i]] = data[i]
                            } else {
                                notObj[keys[i]] = data[i]
                            }
                        } else {
                            notObj[keys[i]] = data[i]
                        }
                    }

                    setObjectResult(obj)
                    setNotObjectResult(notObj)

                    return () => {
                        active = false;
                    };
                }
            }
            getResult().then();
            return () => {
                active = false;
            };
        }
    },[action])

    return (
        <Flex flexDirection='column' pt={{ base: "120px", md: "75px" }}>
            <Header
                BackUrl={'/admin_area/rates'}
                backgroundHeader={BgCharged}
                backgroundProfile={bgProfile}
                avatarImage={forta}
                name={"Курс"}
                email={notObjectResult.id}
                tabs={[
                    {
                        name: "Back",
                        icon: <FaBackspace w='100%' h='100%' />,
                    },
                ]}
            />
            <Grid templateColumns={{ sm: "1fr", xl: "repeat(2, 1fr)" }} gap='22px'>
                {notObjectResult &&
                <ProviderParams
                    title={"info"}
                    params={<pre>{JSON.stringify(notObjectResult, null, 2)}</pre>}
                />
                }

                {objectResult && (
                    Object.keys(objectResult).map( (value, idx) => {
                        return (
                            <ProviderParams
                                key={idx}
                                title={`${value}`}
                                params={<pre>{JSON.stringify(objectResult[value], null, 2)}</pre>}
                            />
                        )
                    }))

                }
            </Grid>
        </Flex>
    );

    async function fetchData(id = 1, token) {
        const response = await axios.get(`/api/v1/fx_rate/${id}`,
            {headers: {Authorization: token}})
        return await response.data

    }
}
